/*import React from 'react';
import { Typography, Container, Grid, Box } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import injupemplogogobierno from '../../../img/injupemplogogobierno.png'

export default function CalculosLeyAnterior({ nombre, apellido, modulo }) {
  const [tabIndex, setTabIndex] = React.useState(5);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const AntTabs = styled(Tabs)({
    borderBottom: '1px solid #e8e8e8',
    '& .MuiTabs-indicator': {
      backgroundColor: '#1890ff',
    },
  });

  const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: 'rgba(0, 0, 0, 0.85)',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&.Mui-selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#d1eaff',
    },
  }));

  return (

    <Grid container direction="column" alignItems="center">
      <Container>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h2>Cálculos</h2>
        </div>
      </Container>
      <Container>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Paper square>
            <AntTabs
              value={tabIndex}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              <AntTab label="Resumen" />
              <AntTab label="Tabla De Interés" />
              <AntTab label="Tasas Por Año" />
              <AntTab label="Monto Del Beneficio" />
              <AntTab label="Datos" />
              <AntTab label="Cálculos" />
              <AntTab label="Rebajas" />
              <AntTab label="Períodos" />
              <AntTab label="Comparativa Devolución 10%" />
              <AntTab label="Con Reingreso" />
            </AntTabs>
          </Paper>
        </Box>

        <Box mt={3}>
          {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
          {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
          {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
          {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
          {tabIndex === 4 && navigate('/Separaciones/LeyAnterior')}
          {tabIndex === 5}
          {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
          {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
          {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
          {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}

        </Box>
      </Container>
      <Grid container item justifyContent="center">
        <img src={injupemplogogobierno} alt="Logo" style={{ width: '80vw' }} />
      </Grid>
    </Grid>
  );
}*/

import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TablePagination, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment } from "@mui/material";
import { Tabs, Tab } from '@mui/material';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow} from '../tabs_style';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

export default function Calculos({ nombre, apellido, modulo }) {
  const [tabIndex, setTabIndex] = React.useState(5);
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const rows = [
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
    {
      mes: "", año: "", sueldo: "", sdiario: "", blanco1: "", blanco2: "", siete: "", blanco3: "", blanco4: "",
      blanco5: "", blanco6: "", pagar: "", rebaja: "", dias: "", rebajalps: ""
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Container>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h2>Cálculos</h2>
          </div>
        </Container>
        <Container>
          <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Paper square>
              <AntTabs
                value={tabIndex}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: { display: 'none' }, // O también puedes usar display: 'none' aquí
              }}
              >
                <AntTab label="Resumen" />
                <AntTab label="Tabla De Interés" />
                <AntTab label="Tasas Por Año" />
                <AntTab label="Monto Del Beneficio" />
                <AntTab label="Datos" />
                <AntTab label="Cálculos" />
                <AntTab label="Rebajas" />
                <AntTab label="Períodos" />
                <AntTab label="Comparativa Devolución 10%" />
                <AntTab label="Con Reingreso" />
              </AntTabs>
            </Paper>
          </Box>

          <Box mt={3}>
            {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
            {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
            {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
            {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
            {tabIndex === 4 && navigate('/Separaciones/LeyAnterior')}
            {tabIndex === 5}
            {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
            {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
            {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
            {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}

          </Box>
        </Container>

      </Grid>

      <Box marginTop={2} boxShadow={2}>
        <Card variant='outlined'>
          <CardContent>

            <Stack direction="row">
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nombre"
                    label="Nombre Correcto"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="nocotizante"
                    label="No. Cotizante"
                    variant="outlined"
                    InputProps={{ readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="suma"
                    label="SUMA"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="sistema"
                    label="SISTEMA"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

            <Stack direction="row" marginTop={1}>
              <Grid container spacing={1}>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="difcot"
                    label="DIF- EN COT"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="difsueldo"
                    label="DIF- EN SUELDO"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                  <TextField
                    id="rebajas"
                    label="REBAJAS"
                    variant="outlined"
                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                  />
                </FormControl>
              </Grid>
            </Stack>

          </CardContent>
        </Card>
      </Box>

      <div>
        <TableContainer component={Paper} style={{ marginTop: 30 }}>
          {/* Tabla 2 */}
          <Table>
            <TableHead>
              <StyledTableRow>
                <StyledTableCell style={{ textAlign: 'center', whiteSpace: 'normal' }}><strong>MES</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>AÑO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>SUELDO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>SDIARIO</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>7%</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong></strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>PAGAR</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>REBAJA 7%</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>DÍAS</strong></StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}><strong>REBAJA LPS</strong></StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : rows
              ).map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.mes}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.año}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.sueldo}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.sdiario}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.blanco2}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.siete}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.blanco3}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}><TextField variant='filled' style={{ minWidth: 94 }} /></StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.pagar}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.rebaja}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.dias}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center', fontSize: 17 }}>{row.rebajalps}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </>
  );
}

